import { render, staticRenderFns } from "./WhatsNew.vue?vue&type=template&id=f3db1378&scoped=true"
import script from "./WhatsNew.vue?vue&type=script&lang=js"
export * from "./WhatsNew.vue?vue&type=script&lang=js"
import style0 from "./WhatsNew.vue?vue&type=style&index=0&id=f3db1378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3db1378",
  null
  
)

export default component.exports